import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface FearGreedHistoryPoint {
  value: number;
  value_classification: string;
  timestamp: string;
  bucket: string;
  color: string;
}

export interface FearGreedHistory {
  points: FearGreedHistoryPoint[];
  source: string;
}

async function fetchHistory(): Promise<FearGreedHistory> {
  const { data, error } = await supabase.functions.invoke("fng-history");
  if (error) throw error;
  return data as FearGreedHistory;
}

export function useFearGreedHistory(enabled = false) {
  return useQuery({
    queryKey: ["fng-history"],
    queryFn: fetchHistory,
    staleTime: 30 * 60 * 1000, // 30 minutes — matches server cache TTL
    refetchOnWindowFocus: false,
    enabled,
  });
}
